import React, { Component} from 'react';

import Select from './../Select';

const data = [
    {value: "助教", label: "助教"},
    {value: "讲师", label: "讲师"},
    {value: "副教授", label: "副教授"},
    {value: "教授", label: "教授"},
    {value: "助理工程师", label: "助理工程师"},
    {value: "工程师", label: "工程师"},
    {value: "高级工程师", label: "高级工程师"},
    {value: "教授级高工", label: "教授级高工"},
    {value: "助理研究员", label: "助理研究员"},
    {value: "副研究员", label: "副研究员"},
    {value: "研究员", label: "研究员"},
    {value: "未评定", label: "未评定"}
];


const Title = (props) => (
    <Select name="title" label="职称" data={data} {...props} ></Select>
);

export default Title;